import * as Sentry from '@sentry/browser'

export const load = async ({ data }) => {
    Sentry.setTag('nf_request_id', data.netlifyRequestId)

    return data
}
